// extracted by mini-css-extract-plugin
module.exports = {"bulk":"BulkOrderForm_bulk__2P27W","StripeElement":"BulkOrderForm_StripeElement__2Dz05","bulkOrderLabel":"BulkOrderForm_bulkOrderLabel__qeZmD"};